package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmName

/**
 * 字符输入事件（已经过 IME / 修饰组合解析后的 Unicode 码点）。
 *
 * @property codepoint Unicode 码点
 * @property modifiers 修饰键位掩码
 */
data class CharEvent(
    // 保留 Java 记录式访问器 ABI：消费方以 `event.codepoint()` 方法式调用
    @get:JvmName("codepoint") val codepoint: Int,
    @get:JvmName("modifiers") val modifiers: Int,
)
